<!--
 * @Author       : aa
 * @Date         : 2020-06-15 12:05:17
 * @Description  : 题号列表
 * @FilePath     : \vue-gaokao-ebook\src\components\paper\card\question_card.vue
--> 
<template>
  <div class="question_card">
    <div class="card">
      <div class="q-index">目录</div>
      <!-- 文科答题卡 -->
      <div
        class="number_list"
        v-if="
          subjectId == 9 ||
          subjectId == 11 ||
          subjectId == 16 ||
          subjectId == 15 ||
          subjectId == 17
        "
      >
        <div
          v-for="(qs, index) in questionStatus"
          :key="index"
          :class="{
            already: qs.status,
            not_yet: !qs.status,
            choose: qs.id == id,
          }"
          :id="'anchor' + qs.id"
          @click="gotoTarget(index)"
          v-html="`第${qs.originalName}题：${getQsType(qs.type_id)}`"
        ></div>
      </div>
      <!-- 理科答题卡 -->
      <div class="number_list" v-else>
        <el-tabs
          tab-position="left"
          style="height: 100%"
          v-model="tabPosition"
          @tab-click="tabelChange"
        >
          <el-tab-pane
            v-for="(qs, key, index) in newQuestionStatus"
            :label="key"
            :name="key"
            :key="index"
          >
            <div
              v-for="(cqs, index) in newQuestionStatus[key]"
              :key="index"
              :class="{
                already: cqs.status,
                not_yet: !cqs.status,
                choose: cqs.id == id,
              }"
              :id="'anchor' + cqs.id"
              @click="gotoTarget(cqs.index)"
              v-html="`${cqs.name}：${getQsType(cqs.type_id)}`"
            >
              <!-- v-html="`${cqs.name}：${getQsType(cqs.type_id, cqs.videoTitle)}`" -->
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- <div class="btns" v-if="questionStatus.length">
      <el-button  :disabled="index == 0"  :class="index == 0 ? 'btn-dis' : 'btn'" @click="gotoTarget(index-1)">上一题</el-button>
      <el-button  :disabled="index == (questionStatus.length-1)" :class="index == (questionStatus.length-1) ? 'btn-dis' : 'btn'" @click="gotoTarget(index+1)">下一题</el-button>
    </div> -->
    <el-dialog
      :close-on-press-escape="true"
      style="margin-top: 60px"
      :append-to-body="true"
      center
      custom-class="success-serve-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogServeVisible"
      v-loading="saveLoading"
    >
      <!-- :show-close="false" -->
      <div>
        <div class="title">
          <img src="../../../assets/images/paper/submit-ok.png" alt />
          <h3>保存成功</h3>
        </div>
        <div class="table-container">
          <div class="item">
            <div class="count">
              本套试卷客观题共{{ savePaperInfo.objective.count }}题
            </div>
            <div class="number">
              作答{{ savePaperInfo.objective.complete }}题
            </div>
            <div class="unnumber">
              未作答{{ savePaperInfo.objective.uncomplete }}题
            </div>
          </div>
          <div class="item">
            <div class="count">
              本套试卷主观题共{{ savePaperInfo.major.count }}题
            </div>
            <div class="number">作答{{ savePaperInfo.major.complete }}题</div>
            <div class="unnumber">
              未作答{{ savePaperInfo.major.uncomplete }}题
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="keepon">继续答题</el-button>
        <el-button type="primary" @click="gohome">结束答题</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-press-escape="true"
      style="margin-top: 60px"
      center
      custom-class="success-serve-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogSubmitVisible"
      :show-close="false"
    >
      <div v-loading="submitLoading">
        <div class="title">
          <img src="../../../assets/images/paper/submit-ok.png" alt />
          <h3>提交成功</h3>
        </div>
        <div class="table-container-submit2">
          <div class="summarize">
            <h3 v-if="!audit_status">
              本套试卷你已得到<span style="color: red; font-size: 22px">{{
                correctScore
              }}</span
              >分，失<span style="color: red; font-size: 22px">{{
                errorScore
              }}</span
              >分，待批改<span style="color: red; font-size: 22px">{{
                unCheckScore
              }}</span
              >分，请点击去自评按钮进行批改。
            </h3>
            <h3 v-if="audit_status">
              本套试卷已批改完毕,你已得到<span
                style="color: red; font-size: 22px"
                >{{ correctScore }}</span
              >分，失<span style="color: red; font-size: 22px">{{
                errorScore
              }}</span
              >分，请点击看错题按钮查看错题。
            </h3>
          </div>
          <div class="table">
            <div class="item">
              <div class="first">
                <div class="line">本套试卷客观题</div>
                <div class="line">
                  共计{{ submitPaperInfo.objective.score }}分
                </div>
              </div>
              <div class="two">
                <div class="line head">
                  得{{ submitPaperInfo.objective.correct_uncheck }}分
                </div>
                <div class="line head">正确 :</div>
                <div class="line">
                  <div
                    class="number"
                    v-for="(number, index) in submitPaperInfo.objective
                      .correct_number"
                    :key="index"
                  >
                    {{ number }}
                  </div>
                </div>
              </div>
              <div class="two">
                <div class="line head">
                  失{{ submitPaperInfo.objective.error_score }}分
                </div>
                <div class="line head">错误 :</div>
                <div class="line">
                  <div
                    class="number"
                    v-for="(number, index) in error_number"
                    :key="index"
                  >
                    {{ number }}
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="first">
                <div class="line">本套试卷主观题</div>
                <div class="line">共计{{ submitPaperInfo.major.score }}分</div>
              </div>
              <div class="two">
                <div class="line head">
                  待批改{{ submitPaperInfo.major.correct_uncheck }}分
                </div>
                <div class="line head">待批改 :</div>
                <div class="line">
                  <div
                    class="number"
                    v-for="(number, index) in submitPaperInfo.major
                      .uncheck_number"
                    :key="index"
                  >
                    {{ number }}
                  </div>
                </div>
              </div>
              <div class="two">
                <div class="line head">
                  失{{ submitPaperInfo.major.error_score }}分
                </div>
                <div class="line head">未作答:</div>
                <div class="line">
                  <div
                    class="number"
                    v-for="(number, index) in submitPaperInfo.major.uncomplete"
                    :key="index"
                  >
                    {{ number }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="!audit_status" @click="toSelfAssessment"
          >去自评</el-button
        >
        <!-- :loading="submitLoading" -->
        <el-button v-if="audit_status" @click="toSelfResult"
          >查看结果</el-button
        >
        <!--  :loading="submitLoading" -->
        <el-button type="primary" @click="toWorngQuestion">看错题</el-button>
        <!--  :loading="submitLoading" -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import typeNameMap from "@/assets/js/composite_question_type";
export default {
  props: {
    subjectId: Number,
    newQuestionStatus: Object,
    questionStatus: Array,
    questionSubmitInfo: Object,
    fullScore: Number,
    majorQuesitonScore: Number,
    costTime: Number,
    appid: Number,
    questionTab: Number,
  },
  data() {
    return {
      model: "",
      typeNameMap,
      answerTimes: 0,
      monthNum: 0,
      monthCardNum: 0,
      userInfo: {},
      isAgent: false,
      agentInfo: {},
      tabPosition: "0",
      id: 0,
      question_tab: 1,
      index: 0,
      dialogServeVisible: false,
      dialogSubmitVisible: false,
      submitLoading: false,
      saveLoading: false,
      savePaperInfo: {
        major: {
          count: 0,
          complete: 0,
          uncomplete: 0,
        },
        objective: {
          count: 0,
          complete: 0,
          uncomplete: 0,
        },
      },
      tableSavePaperData: [],
      correctScore: 0,
      errorScore: 0,
      unCheckScore: 0,

      submitPaperInfo: {
        objective: {
          score: 0,
          correct_uncheck: 0,
          error_score: 0,
          correct_number: [],
          error_number: [],
          uncomplete: [],
        },

        major: {
          score: 0,
          correct_uncheck: 0,
          error_score: 0,
          uncheck_number: [],
          uncomplete: [],
        },
      },
      error_number: [],
      audit_status: true,
      orderNumber: "",
    };
  },
  methods: {
    getQsType(typeId) {
      // 设置提类型
      return typeNameMap[typeId];
    },
    tabelChange(val) {
      let index = this.newQuestionStatus[val.label][0].index;
      this.gotoTarget(index);
    },
    keepon() {
      this.dialogServeVisible = false;
      this.tableSavePaperData = [];
      this.$emit("starTime");
    },
    toSelfResult() {
      this.$router.push(
        "/evaluated_detail?paper_id=" +
          this.questionSubmitInfo.paper_id +
          "&test_id=" +
          this.questionSubmitInfo.test_id +
          "&app_id=" +
          this.appid
      );
    },
    toSelfAssessment() {
      this.$root.eventHub.$emit("changePath", "my_evaluation");
      this.$router.push({
        path: "/self_assessment",
        query: {
          paper_id: this.questionSubmitInfo.paper_id,
          test_id: this.questionSubmitInfo.test_id,
          app_id: this.appid,
        },
      });
    },
    gohome() {
      this.$root.eventHub.$emit("changePath", "home");
      this.$router.push("/tfedu_common/home");
    },

    toWorngQuestion() {
      if (this.model == "client") {
        // 客户端
        this.$router.push(
          `/client_wrong_topic?subject_id=${this.subjectId}&source=2&pid=${this.questionSubmitInfo.paper_id}&app_id=${this.appid}`
        );
      } else {
        this.$router.push(
          `/wrong_topic?subject_id=${this.subjectId}&source=2&app_id=${this.appid}`
        );
      }
    },
    progressFormat() {
      return `共${this.qsAllNumber}题`;
    },
    timeFormat() {
      return `共${this.allTime}分钟`;
    },
    gotoTarget(indexChanged) {
      localStorage.setItem("flagFirst", "true");
      this.index = indexChanged;
      let qs = this.questionStatus[indexChanged];
      this.id = qs.id;
      let pid = qs.parent_id || 0;
      this.question_tab = qs.order;
      this.$root.eventHub.$emit("question-q-id", qs.id, pid);
      this.$root.eventHub.$emit("question-tab-changed", qs.order);
      if (
        this.subjectId == 10 ||
        this.subjectId == 12 ||
        this.subjectId == 13 ||
        this.subjectId == 14
      ) {
        for (const key in this.newQuestionStatus) {
          for (
            let index = 0;
            index < this.newQuestionStatus[key].length;
            index++
          ) {
            const element = this.newQuestionStatus[key][index];
            let pid = element.parent_id || 0;
            if (element.index == indexChanged) {
              this.tabPosition = key;
              this.$root.eventHub.$emit("question-q-id", element.id, pid);

              return false;
            }
          }
        }
      }
    },
    submit_paper() {
      //  计算得分,失分,和待批改的分 , 计算主观题|客观题得分,失去分,和待批改分
      //  统计主观题|客观题得分,失分,待批改分,已经作答和未作答的题号
      // console.log("fullScore : ",this.fullScore,"this.objectiveScore : ",this.objectiveScore,"this.majorQuesitonScore:",this.majorQuesitonScore);
      //总的信息
      let resultScore = this.fullScore;
      let resultError = 0;
      let resultNoComplete = 0;
      //客观题分数信息
      let objectiveScore = 0;
      let objectiveCorrectScore = 0;
      let objectiveErrorScore = 0;
      //客观题题号集合
      let objectiveCorrectNumbers = [];
      let objectiveErrorNumbers = [];
      let unCompleteNumbers = [];
      //主观题分数信息
      let majorScore = 0;
      let majorErrorScore = 0;
      let majorNoCheckScore = 0;
      //主观题题号集合
      let majorErrorNumbers = [];
      let majorNoCheckNumbers = [];
      let majorNoCompleteNumbers = [];
      let qs = this.questionStatus;

      //选做题的集合
      let chooseQuestion = [];
      //需要判断题是主观题|客观题,是否正确,是否批改
      qs.forEach((q) => {
        if (q.parent_typeId != 229 && q.parent_typeId != 234) {
          if (this.questionIsMajor(q)) {
            majorScore += q.question_score;
            if (q.status) {
              majorNoCheckScore += q.question_score;
              majorNoCheckNumbers.push(q.card_originalName);
            } else {
              majorErrorScore += q.question_score;
              majorErrorNumbers.push(q.card_originalName);
              majorNoCompleteNumbers.push(q.card_originalName);
            }
            //如果有主观题的状态是未批改的,则卷子需要批改
            if (!q.audit_status) {
              this.audit_status = false;
            }
          } else {
            objectiveScore += q.question_score;
            if (q.correct) {
              objectiveCorrectScore += q.question_score;
              objectiveCorrectNumbers.push(q.card_originalName);
            } else {
              if (q.type_code == "E" && q.answerUnicity && q.score > 0) {
                if (q.score > 0) {
                  objectiveCorrectScore += q.score;
                  objectiveCorrectNumbers.push(q.card_originalName);
                }

                objectiveErrorScore += q.question_score - q.score;
                objectiveErrorNumbers.push(q.card_originalName);
              } else if (q.type_id == 40) {
                if (q.score > 0) {
                  objectiveCorrectScore += q.score;
                  objectiveCorrectNumbers.push(q.card_originalName);
                }
                objectiveErrorScore += q.question_score - q.score;
                objectiveErrorNumbers.push(q.card_originalName);
              } else {
                if (q.score > 0) {
                  objectiveCorrectScore += q.score;
                  objectiveCorrectNumbers.push(q.card_originalName);
                }
                objectiveErrorScore += q.question_score - q.score;
                objectiveErrorNumbers.push(q.card_originalName);
              }
            }
            if (!q.status) {
              unCompleteNumbers.push(q.card_originalName);
            }
          }
        } else {
          chooseQuestion.push(q);
        }
      });

      let map = new Map();
      //解决选做题的分数
      for (let i = 0; i < chooseQuestion.length; i++) {
        let item = chooseQuestion[i];
        if (null == map.get(item.parent_id)) {
          let array = new Array();
          array.push(item);
          map.set(item.parent_id, array);
        } else {
          let array = map.get(item.parent_id);
          array.push(item);
        }
      }

      map.forEach((value) => {
        let array = value;
        let q = array[0];
        if (this.questionIsMajor(q)) {
          majorScore += q.question_score;
        } else {
          objectiveScore += q.question_score;
        }
        let status = false;
        let audit_status = true;
        let correct = false;
        //循环内部,只处理题号
        array.forEach((q) => {
          if (q.status) {
            status = true;
            if (this.questionIsMajor(q)) {
              majorNoCheckNumbers.push(q.card_originalName);
            }
          } else {
            if (this.questionIsMajor(q)) {
              majorNoCompleteNumbers.push(q.card_originalName);
            } else {
              objectiveErrorNumbers.push(q.card_originalName);
            }
          }
          if (!q.audit_status) {
            audit_status = false;
          }
          if (!this.questionIsMajor(q)) {
            if (q.correct) {
              correct = true;
              objectiveCorrectNumbers.push(q.card_originalName);
            } else {
              objectiveErrorNumbers.push(q.card_originalName);
            }
          }
        });
        //外部 -- > 只处理分数相关
        if (status) {
          //如果状态是完成的
          //如果是主观题,增加主关未评分数
          if (this.questionIsMajor(q)) {
            majorNoCheckScore += q.question_score;
          }
        } else {
          //如果是未完成的,增加未做分数,考虑到是选做题, 则只取一个分数就可以了
          if (this.questionIsMajor(q)) {
            majorErrorScore += q.question_score;
          } else {
            objectiveErrorScore += q.question_score;
          }
        }
        //如果有题是未评的,则卷子改为未平的
        if (!audit_status) {
          if (this.questionIsMajor(q)) {
            this.audit_status = false;
          }
        }

        //客观题
        if (!this.questionIsMajor(q)) {
          if (correct) {
            //如果是正确的,则添加一个题的分数
            objectiveCorrectScore += q.question_score;
          } else {
            objectiveErrorScore += q.question_score;
          }
        }
      });
      this.submitPaperInfo.objective = {
        score: objectiveScore,
        correct_uncheck: objectiveCorrectScore,
        error_score: objectiveErrorScore,
        correct_number: objectiveCorrectNumbers,
        error_number: objectiveErrorNumbers,
        uncomplete: objectiveErrorNumbers,
      };
      this.error_number = objectiveErrorNumbers;
      this.submitPaperInfo.major = {
        score: majorScore,
        correct_uncheck: majorNoCheckScore,
        error_score: majorErrorScore,
        uncheck_number: majorNoCheckNumbers,
        uncomplete: majorNoCompleteNumbers,
      };
      this.correctScore = objectiveCorrectScore;
      this.errorScore = objectiveErrorScore + majorErrorScore;
      this.unCheckScore = majorNoCheckScore;
      let paper_submit_data = {
        paper_id: this.questionSubmitInfo.paper_id,
        test_id: this.questionSubmitInfo.test_id,
        user_id: this.questionSubmitInfo.user_id,
        audit_status: this.audit_status,
        questions: this.questionStatus,
        order_number: this.orderNumber || null,
        time_used: this.costTime,
        // score: this.submitPaperInfo.objective.score + this.submitPaperInfo.major.score,
      };
      // 判断是不是代理商
      //  月卡 &&　次数ｙｏｕ　・・ 次数为0 && compaStatu == 0
      if (!this.monthCardNum) {
        if (this.isAgent) {
          // 是代理商
          // 学科是什么
          if (this.subjectId == 9) {
            // 语文
            if (this.agentInfo.yuwenTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 10) {
            // 数学
            if (this.agentInfo.shuxueTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 11) {
            if (this.agentInfo.yingyuTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 12) {
            if (this.agentInfo.wuliTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          }
        }
      }
      // 判断是否有未完成的题目
      let isComplete = false;
      for (let i = 0; i < this.questionStatus.length; i++) {
        const element = this.questionStatus[i];
        if (!element.status) {
          isComplete = true;
        }
      }
      if (isComplete) {
        this.$confirm("有未作答的题目 确定要提交吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.dialogSubmitVisible = true;
          this.submitLoading = true;
          this.$store.dispatch("actionsSetPaperData", paper_submit_data);
          this.$HTTP
            .executePost(this.$APIS.PAPER_SUBMIT, paper_submit_data, this)
            .then((res) => {
              if (res.code == 0) {
                this.submitLoading = false;
              } else {
                this.$message(res.msg);
              }
            });
        });
      } else {
        this.dialogSubmitVisible = true;
        this.submitLoading = true;
        this.$store.dispatch("actionsSetPaperData", paper_submit_data);
        this.$HTTP
          .executePost(this.$APIS.PAPER_SUBMIT, paper_submit_data, this)
          .then((res) => {
            if (res.code == 0) {
              this.submitLoading = false;
            } else {
              this.$message(res.msg);
            }
          });
      }
    },
    async save_paper() {
      this.dialogServe;
      this.dialogServeVisible = true;
      this.$emit("clearTimer");
      let qs = this.questionStatus;
      //总体数,客观题 : 数量,已作答数,客观题: 数量,已作答数
      let questionNumber = 0;
      let objectiveNumber = 0;
      let objectiveRespondNumber = 0;
      let objectiveNoRespondNumber = 0;
      let majorNumber = 0;
      let majorRespondNumber = 0;
      let majorNoRespondNumber = 0;
      questionNumber = qs.length;
      qs.forEach((q) => {
        if (this.questionIsMajor(q)) {
          majorNumber++;
          if (q.status) {
            majorRespondNumber++;
          }
        } else {
          if (q.status) {
            objectiveRespondNumber++;
          }
        }
      });
      objectiveNumber = questionNumber - majorNumber;
      majorNoRespondNumber = majorNumber - majorRespondNumber;
      objectiveNoRespondNumber = objectiveNumber - objectiveRespondNumber;

      this.savePaperInfo = {
        major: {
          count: majorNumber,
          complete: majorRespondNumber,
          uncomplete: majorNoRespondNumber,
        },
        objective: {
          count: objectiveNumber,
          complete: objectiveRespondNumber,
          uncomplete: objectiveNoRespondNumber,
        },
      };
      this.saveLoading = true;
      let paper_submit_data = {
        paper_id: this.questionSubmitInfo.paper_id,
        test_id: this.questionSubmitInfo.test_id,
        user_id: this.questionSubmitInfo.user_id,
        audit_status: false, //批改状态为false
        questions: this.questionStatus,
        time_used: this.costTime,
      };
      await this.$HTTP
        .executePost(this.$APIS.PAPER_SAVE, paper_submit_data, this)
        .then((res) => {
          if (res.code == 0) {
            this.dialogServeVisible = true;
          } else {
            this.$message.error("保存失败请重试！");
          }
          this.saveLoading = false;
        });
    },
    questionIsMajor(question) {
      if (question.type_code == "S") {
        return true;
      }
      if (question.type_code == "E" && !question.answerUnicity) {
        return true;
      }
      return false;
    },
    // 写一个函数来执行
    async getChance(cData) {
      let monthIsOk = false;
      let user_json = localStorage.getItem("userinfo");
      let userInfo = JSON.parse(user_json);
      for (let i = 0; i < cData.length; i++) {
        const element = cData[i];
        if (element.subjects.indexOf(this.subjectId) != -1) {
          this.monthNum = element.paperNum;
          this.answerTimes = element.answerTimes;
          let sParams = {
            userId: userInfo.id,
            subjectId: this.subjectId,
            createDate: new Date(element.createTime),
            endDate: new Date(element.createTime + element.indate),
          };
          await this.$HTTP
            .executePost(this.$APIS.GET_CARD_INFOPAPER_NUM, sParams, this)
            .then((res) => {
              if (res.code === 0) {
                if (res.data != null && res.data.length) {
                  let isPaper = false; // 当前试卷是否存在
                  for (let j = 0; j < res.data.length; j++) {
                    const element = res.data[j];
                    if (element.paperId == this.questionSubmitInfo.paper_id) {
                      isPaper = true;
                    }
                  }
                  if (isPaper) {
                    // 存在
                    for (let z = 0; z < res.data.length; z++) {
                      const element2 = res.data[z];
                      if (
                        element2.paperId == this.questionSubmitInfo.paper_id
                      ) {
                        if (element2.completeTimes < this.answerTimes) {
                          this.monthCardNum = 1;
                          return false;
                        }
                        // if (element2.completeStatus == 0 && res.data.length <= this.monthNum) { // 未完成
                        //   this.monthCardNum = 1
                        //   return false
                        // }
                      }
                    }
                  } else {
                    // 不存在
                    if (res.data.length < this.monthNum) {
                      this.monthCardNum = 1;
                      return false;
                    }
                  }
                } else {
                  this.monthCardNum = 1;
                  return false;
                }
              }
            });
        }
      }
    },
  },
  created() {
    this.model = localStorage.getItem("model") || this.$route.query.model || "";
    let user_json = localStorage.getItem("userinfo");
    let userInfo = JSON.parse(user_json);
    this.$HTTP
      .executeGet(`${this.$APIS.GET_VIP_CARD_INFO}/${userInfo.id}/1`, this)
      .then((res) => {
        if (res.code == 0) {
          // 是有月卡
          let mate = false;
          if (res.data != null) {
            for (let index = 0; index < res.data.length; index++) {
              const element = res.data[index];
              if (element.subjects.indexOf(this.subjectId) != -1) {
                mate = true;
              }
            }
          }
          // 有月卡
          if (mate) {
            this.getChance(res.data);
          } else {
            this.monthCardNum = 0;
          }
        }
      });
  },
  mounted() {
    this.id = this.questionStatus[0].id;
    this.question_tab = this.questionStatus[0].order;
    this.tabPosition = "1";
    this.orderNumber = this.$route.query.order_number;
    this.$root.eventHub.$emit("question-tab-changed", this.question_tab);
    this.$root.eventHub.$on("question-tab-changed1", (order) => {
      let array = this.questionStatus;
      for (let index = 0; index < array.length; index++) {
        let element = array[index];
        if (element.order == order) {
          this.index = index;
          this.id = element.id;
          this.question_tab = element.order;
        }
      }
    });

    let user_json = localStorage.getItem("userinfo");
    this.userInfo = JSON.parse(user_json);
    this.$HTTP
      .executeGet(`${this.$APIS.GET_BY_CHAGEID}/${this.userInfo.id}`, this)
      .then((res) => {
        if (!res.code) {
          // 是代理商
          if (res.data != null && res.data.id) {
            // 是代理商
            this.isAgent = true;
            this.agentInfo = res.data;
          }
        } else {
          console.log("不是代理商");
        }
      });
    this.question_tab = this.$route.query.question_tab || this.question_tab;
    this.$nextTick(() => {
      // debugger;
      if (
        this.subjectId == 10 ||
        this.subjectId == 12 ||
        this.subjectId == 13 ||
        this.subjectId == 14
      ) {
        for (const key in this.newQuestionStatus) {
          for (
            let index = 0;
            index < this.newQuestionStatus[key].length;
            index++
          ) {
            const element = this.newQuestionStatus[key][index];
            let pid = element.parent_id || 0;
            if (element.original == this.question_tab) {
              this.tabPosition = key;
              this.index = index;
              let qs = this.questionStatus[index];
              this.id = element.id;
              let pid = qs.parent_id || 0;
              this.question_tab = qs.order;
              this.$root.eventHub.$emit("question-q-id", element.id, pid);
              this.$root.eventHub.$emit("question-tab-changed", qs.order);
              localStorage.setItem("flagFirst", "true");
              break;
            }
          }
        }
      } else {
        for (let i = 0; i < this.questionStatus.length; i++) {
          const e = this.questionStatus[i];
          if (e.order == this.question_tab) {
            // this.tabPosition = key
            this.index = i;
            this.id = e.id;
            let pid = e.parent_id || 0;
            // this.question_tab = qs.order;
            this.$root.eventHub.$emit("question-q-id", e.id, pid);
            this.$root.eventHub.$emit("question-tab-changed", e.order);
            localStorage.setItem("flagFirst", "true");
            break;
          }
        }
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.question_card {
  width: 300px;
  height: 100%;
  overflow: auto;
  .card {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    .q-index {
      line-height: 50px;
      font-size: 24px;
      width: 100%;
      text-align: center;
    }
    .number_list {
      width: 280px;
      height: auto;
      padding-bottom: 5px;

      .already {
        padding-left: 15px;
        width: 100%;
        height: 50px;
        margin-top: 1px;
        text-align: center;
        line-height: 50px;
        font-size: 17px;
        background-color: #5c307d;
        color: #fff;
        cursor: pointer;
      }

      .not_yet {
        width: 100%;
        padding-left: 15px;
        height: 50px;
        margin-top: 1px;
        border-bottom: 1px solid #efefef;
        line-height: 50px;
        font-size: 16px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .not_yet:hover {
        background-color: #5c307d;
        color: #fff;
      }

      .choose {
        width: 100%;
        padding-left: 15px;
        height: 50px;
        margin-top: 1px;
        line-height: 50px;
        font-size: 16px;
        background-color: #5c307d;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.success-serve-dialog {
  height: 534px;
  width: 951px;

  .title {
    padding: 0 !important;
    margin: 0 !important;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
      border-radius: 25px;
    }

    h3 {
      font-size: 23px;
      margin-left: 30px;
      color: #272727;
    }
  }
  .table-container {
    padding: 0 !important;
    margin: 0 !important;
    display: -webkit-flex;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    height: 450px;
    width: 100%;
    /deep/ .el-table {
      width: auto !important;
      max-width: 647px !important;
    }
    .item {
      height: 50px;
      width: 471px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .count {
        display: inline-block;
      }
      .number {
        display: inline-block;
      }
      .unnumber {
        display: inline-block;
      }
    }
  }
  .table-container-submit {
    padding: 0 !important;
    margin: 0 !important;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 350px;
    width: 100%;
    /deep/ .el-table {
      width: auto !important;
      max-width: 647px !important;
    }
  }
  .table-container-submit2 {
    height: 450px;
    width: 100%;
    .summarize {
      width: 100%;
      float: left;
      height: 30px;
      line-height: 50px;
      text-align: center;
      h3 {
        font-size: 18px;
      }
    }
    .table {
      margin-left: 68px;
      margin-top: 20px;
      float: left;
      width: auto;
      height: 291px;
      border: 1px solid #aaaaaa;
      border-bottom: none;
      border-right: none;
      .item {
        display: flex;
        width: auto;
        height: 145px;
        border-bottom: 1px solid #aaaaaa;
        .first {
          height: 144px;
          width: 211px;
          border-right: 1px solid #aaaaaa;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .line {
            width: 100%;
            font-size: 18px;
            text-align: center;
            padding: 15px auto;
            overflow-y: auto;
            min-height: 20%;
            .number {
              display: inline-block;
              border: 1px solid #67b8ff;
              min-width: 30px;
              height: 30px;
              color: #67b8ff;
              line-height: 1.45;
              font-size: 12px;
              margin-left: 10px;
              padding-left: 2px;
              padding-right: 2px;
              margin-top: 10px;
              line-height: 30px;
            }
          }
        }
        .two {
          height: 143px;
          width: 300px;
          border-right: 1px solid #aaaaaa;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .line {
            width: 100%;
            font-size: 16px;
            padding: 15px auto;
            overflow-y: auto;
            min-height: 20%;
            .number {
              text-align: center;
              display: inline-block;
              border: 1px solid #67b8ff;
              min-width: 30px;
              height: 30px;
              color: #67b8ff;
              font-size: 12px;
              margin-left: 10px;
              padding-left: 2px;
              padding-right: 2px;
              justify-content: center;
              margin-top: 10px;
              line-height: 30px;
            }
          }
          .head {
            text-align: center;
          }
        }
      }
    }
  }
}

.el-progress-bar {
  width: 80%;
}

.el-dialog__body {
  font-size: 18px;
  padding: 0 !important;
  margin: 0 !important;
  height: 400px;
}
.progress-time {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 30px;
  padding: 0 40px;
  margin-left: 80px;
}

.progress-time-box {
  width: 76%;
  margin-left: 136px;
  margin-top: 119px;

  >>> .progressbar {
    .el-progress__text {
      font-size: 18px !important;
    }
  }
}

.el-progress-bar {
  width: 100%;
}

.el-progress__text {
  font-size: 18px !important;
}
>>> .el-carousel__arrow {
  top: 68% !important;
}
</style>
